// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"login_pageWrapper__lbdvG","loginContainer":"login_loginContainer__NKind","title":"login_title__zsZcM","input":"login_input__53WmV","button":"login_button__3kGFd"};